import {useEffect, useRef} from 'react'
import {Image} from '@primer/react-brand'

import Mona from './_assets/cat.webp'
import Copilot from './_assets/copilot.webp'
import Duck from './_assets/duck.webp'
import Butterfly from './Butterfly/Butterfly'

import Styles from './Visual.module.css'

export function Visual() {
  const visualRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!visualRef.current) return
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (reduceMotion) {
      visualRef.current.classList.add(Styles.NoAnimation)
      return
    } else {
      const observer = new IntersectionObserver(
        entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              if (visualRef.current) {
                visualRef.current.classList.add(Styles.Animation)
                observer.unobserve(visualRef.current)
              }
            }
          }
        },
        {threshold: 0.5},
      )

      observer.observe(visualRef.current)
    }
  }, [])
  return (
    <div className={Styles.Visual} ref={visualRef}>
      <div className={Styles.VisualWrapper}>
        <Image className={Styles.Mona} src={Mona} alt="" loading="lazy" />
        <Image className={Styles.Copilot} src={Copilot} alt="" loading="lazy" />
        <Image className={Styles.Duck} src={Duck} alt="" loading="lazy" />
        <Butterfly />
      </div>
    </div>
  )
}

try{ Visual.displayName ||= 'Visual' } catch {}